import { render, staticRenderFns } from "./SectorTagsModal.vue?vue&type=template&id=e371e288&scoped=true&"
import script from "./SectorTagsModal.vue?vue&type=script&lang=js&"
export * from "./SectorTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e371e288",
  null
  
)

export default component.exports